import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Terms from '@/components/Terms'
import Privacy from '@/components/Privacy'
Vue.use(Router)

export default new Router({
  mode:'history'
  ,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Privacy
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js